export default __webpack_public_path__ + "static/dge-cover-small-f4f4ae7c9836a367f64b0d377a9375af.webp";